import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompanyService } from './../../services/company.service';
import { FactLanguageService } from './../../services/fact-language.service';
import { EncrDecrService } from './../../services/encr-decr.service';
declare var $: any;

@Component({
  selector: 'app-s-customer-list',
  templateUrl: './s-customer-list.component.html',
  styleUrls: ['./s-customer-list.component.css']
})
export class SCustomerListComponent implements OnInit {

  dtOptions: DataTables.Settings = {};

  public data: Object;
  public temp_var: Object = false;
  user_id: any = '';
  token: any = '';
  APIKEY: any = 'SOAV2@123';
  sendCmpInfo: any = {};
  delete_cmp_id: any;
  cmp_status: any;
  cmp_id: any;
  statusValue: any = '';
  role_id: any = '';
  loaderMode: any = false;

  constructor(private _company: CompanyService,
    private _router: Router,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,
    private _activatedroute: ActivatedRoute,) { }

  ngOnInit(): void {

    this.dtOptions = {
      scrollY: '300',
      scrollX: true,
    };

    this.user_id = localStorage.getItem('id');
    this.role_id = localStorage.getItem('role_id');
    this.token = localStorage.getItem('token');


    this._activatedroute.params.subscribe(params => {
      this.statusValue = params['status'];
    });

    this.sendCmpInfo = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      status: this.statusValue,
    };
    this._company.getCompanyList(this.sendCmpInfo)
      .subscribe(
        res => {
          //  console.log(res);
          this.data = res;
          this.temp_var = true;
        },
      );
    if (this.role_id == 1 || this.role_id == 2 || this.role_id == 431) {

    }
    else {
      this._router.navigate(["/login"]);

    }
  }
  onChangeEvent(ev) {
    const status = ev.target.value;
    this._router.navigateByUrl('/redirect').then(() => {
      this._router.navigateByUrl('/super-admin/customer-list/' + status);
    });
  }
  getCompanyList(status) {
    this.statusValue = this.cmp_status;
    this.sendCmpInfo["status"] = this.cmp_status;
    //console.log(this.sendCmpInfo);
    this._company.getCompanyList(this.sendCmpInfo)
      .subscribe(
        res => {
          this.data = res;
          this.temp_var = true;
        },
      );
  }
  delete_user() {
    const data = {
      cmp_id: this.delete_cmp_id,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
    }
    this._company.deleteCompany(data)
      .subscribe(
        res => {
          // this.ngOnInit();
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/super-admin/customer-list/active');
          });
          this.toastr.success(res.message, 'Success');
        },
        err => console.log(err)
      );
  }
  set_delete_id(cid) {
    this.delete_cmp_id = cid;
  }
  active_customer() {
    const data = {
      company_id: this.cmp_id,
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      status: this.cmp_status,
    }
    this._company.activeCmp(data)
      .subscribe(
        res => {
          //this.ngOnInit();
          this.toastr.success(res.message, 'Success');
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/super-admin/customer-list/active');
          });
        },
        err => console.log(err)
      );
    // this.refresh();
  }

  set_active_id(cid, status) {
    this.cmp_id = cid;
    this.cmp_status = status;
  }

  refresh(): void {
    window.location.reload();
  }
  companyLogin(value) {
    //console.log(value);

    this.loaderMode = true;
    const data = {
      company_id: value,
      APIKEY: this.APIKEY
    }


    this._company.getCompanyUserById(data)
      .subscribe(
        res => {
          //console.log(res);
          if (res.status == true) {
            // this.spinnerService.hide();
            localStorage.setItem('currentUser', JSON.stringify(res));
            localStorage.setItem("id", res.data.id);
            localStorage.setItem("company_id", res.data.company_id);
            localStorage.setItem("role_id", res.data.role_id);
            localStorage.setItem("role_name", res.data.role_name);
            localStorage.setItem("loginType", 'superAdmin');
            localStorage.setItem("adminId", this.user_id);

            if (res.data.role_name != 'Mobile User') {

              if (res.data.role_id == 1 || res.data.role_id == 2 || res.data.role_id == 431) {
                this._router.navigate(["/super-admin/customer-list/active"]);
              }
              else {
                //this._router.navigate(["/customer/customer-list/active"]);
                //link chanaged by deepak on 14Feb2022
                this._router.navigate(["/mobile/mobile-list"]);
              }
            }
            else {
              this._router.navigate(["/mobile/mobile-list"]);
            }
          }
          else {
            alert(res.message);

          }
        },
        err => console.log(err)
      );
  }

  redirectedinto(c_id) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), c_id);
    this._router.navigate(["/super-admin/edit-customer/" + encrypted]);
  }

  redirected(c_id) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), c_id);
    this._router.navigate(["/super-admin/view-customer/" + encrypted]);
  }

}
